import React from 'react';

import { CrossCircleIcon } from '@vlabs/icons';
import { useHasPermission } from '@vlabs/permissions';
import { useModal } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button';
import { useTranslation } from 'react-i18next';

import { ClearLists } from './ClearLists';

interface ClearListsButtonProps {
  listIds: string[];
  onClearLists?: VoidFunction;
  enabled?: boolean;
  'data-testid'?: string;
  size?: 'small' | 'medium';
  variant?: string;
}

function ClearListsButton({
  listIds,
  onClearLists = undefined,
  enabled = true,
  'data-testid': dataTestId = undefined,
  ...props
}: ClearListsButtonProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const modal = useModal();
  const canDeleteCards = useHasPermission('card', 'delete');
  const canUpdateLists = useHasPermission('list', 'update');

  if (!canDeleteCards && !canUpdateLists) return null;

  return (
    <React.Fragment>
      {modal.wrap(
        <ClearLists
          listIds={listIds}
          onCancel={modal.close}
          onClearLists={onClearLists}
        />,
      )}

      <Button
        data-testid={dataTestId}
        disabled={!enabled}
        icon={<CrossCircleIcon />}
        onClick={modal.open}
        variant="flat"
        {...props}
      >
        {t('features:clear_lists.btn.clear')}
      </Button>
    </React.Fragment>
  );
}

export { ClearListsButton };
